const superscriptDigits = {
  '⁰': '0',
  '¹': '1',
  '²': '2',
  '³': '3',
  '⁴': '4',
  '⁵': '5',
  '⁶': '6',
  '⁷': '7',
  '⁸': '8',
  '⁹': '9'
};

document.querySelectorAll('.article-view__rte').forEach((articleBody) => {
  if (articleBody.dataset.footnotesNormalized === 'true') return;

  const walker = document.createTreeWalker(articleBody, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((textNode) => {
    if (!/[⁰¹²³⁴⁵⁶⁷⁸⁹]/.test(textNode.nodeValue)) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    textNode.nodeValue.replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹]+/g, (match, offset) => {
      fragment.append(textNode.nodeValue.slice(lastIndex, offset));

      const footnote = document.createElement('sup');
      footnote.className = 'mc-article-footnote';
      footnote.textContent = Array.from(match).map((digit) => superscriptDigits[digit]).join('');
      fragment.append(footnote);
      lastIndex = offset + match.length;
    });

    fragment.append(textNode.nodeValue.slice(lastIndex));
    textNode.replaceWith(fragment);
  });

  articleBody.dataset.footnotesNormalized = 'true';
});
